/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Point_1_LabelInputs */

const en_visa_e2_point_1_label = /** @type {(inputs: Visa_E2_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Structure Review`)
};

const pt_visa_e2_point_1_label = /** @type {(inputs: Visa_E2_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão da Estrutura Empresarial`)
};

const es_visa_e2_point_1_label = /** @type {(inputs: Visa_E2_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión de la Estructura Empresarial`)
};

/**
* | output |
* | --- |
* | "Business Structure Review" |
*
* @param {Visa_E2_Point_1_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_point_1_label = /** @type {((inputs?: Visa_E2_Point_1_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Point_1_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_point_1_label(inputs)
	if (locale === "es") return es_visa_e2_point_1_label(inputs)
	return en_visa_e2_point_1_label(inputs)
});